import { Record } from 'immutable';

const UserPermissionRecord = Record({
  token: null,
  permissions: []
});

export class UserPermission extends UserPermissionRecord {
  token: string;
  permissions: string[];
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/permission/models/user-permission.model.ts